// import React, { useEffect, useState } from 'react';
// import { Navbar, Nav, Badge, NavDropdown } from 'react-bootstrap';
// import HeaderTop from './HeaderTop';
// import { Link } from 'react-router-dom';
// import { fetch } from '../../utils';
// import { useSelector } from 'react-redux';
// import CartSidebar from '../component/CartSidebar';
// import SearchComponet from '../component/SearchComponet';

// const MainHeader = () => {
//     const cart = useSelector((state) => state.cart.items);
//     const wishlistData = useSelector((state) => state.wishlistData);

//     const [active, setActive] = useState("home");
//     const [categoryList, setCategoryList] = useState([]);
//     const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);
//     const [isOverlayActive, setIsOverlayActive] = useState(false);

//     const getCategryList = async () => {
//         try {
//             const response = await fetch("/category/hierarchy", "get", null, null);
//             setCategoryList(response.data.data.category || []);
//         } catch (err) {
//             console.log(err);
//         }
//     };

//     useEffect(() => {
//         getCategryList();
//     }, []);

//     const openCartSidebar = () => {
//         setIsCartSidebarOpen(true);
//         setIsOverlayActive(true);
//     };

//     const closeCartSidebar = () => {
//         setIsCartSidebarOpen(false);
//         setIsOverlayActive(false);
//     };

//     const tokenDataFromLocalStorage = localStorage.getItem("muskan_token_data");
//     const parsedTokenData = tokenDataFromLocalStorage
//         ? JSON.parse(tokenDataFromLocalStorage)
//         : null;

//     return (
//         <>
//             <HeaderTop />

//             <div
//                 className={`overlay ${isOverlayActive ? 'active' : ''}`}
//                 onClick={closeCartSidebar}
//             ></div>

//             <section className="navigation">
//                 <Navbar collapseOnSelect expand="lg">
//                     <div className="container-fluid">

//                         {/* Logo */}
//                         <Navbar.Brand
//                             as={Link}
//                             to="/"
//                             className="navbar-brand"
//                             aria-label="Sakhi Logo"
//                         >
//                             <picture>
//                                 <img
//                                     decoding="async"
//                                     loading="lazy"
//                                     src={require('../assets/images/logo.webp')}
//                                     alt="Sakhi"
//                                     className="img-fluid logo-width"
//                                 />
//                             </picture>
//                         </Navbar.Brand>

//                         {/* Mobile Icons */}
//                         <div className="d-inline-flex d-lg-none ms-auto ">

//                             <Nav.Item className="px-1 pt-1">
//                                 <Link
//                                     to="/wishlist"
//                                     className="nav-link pt-2 px-1 whishlist-nav"
//                                 >
//                                     <Badge bg="danger" className="rounded-5">
//                                         {wishlistData.wishListDataCount.length}
//                                     </Badge>
//                                     <i className="fa fa-heart-o"></i>
//                                 </Link>
//                             </Nav.Item>

//                             <Nav.Item className="px-2 pt-1">
//                                 <Link
//                                     className="nav-link pt-2 px-1 whishlist-nav"
//                                     onClick={openCartSidebar}
//                                 >
//                                     <Badge bg="danger" className="rounded-5">
//                                         {cart.length}
//                                     </Badge>
//                                     <i className="fa fa-shopping-bag"></i>
//                                 </Link>
//                             </Nav.Item>

//                             <Nav.Item className="px-1 pt-1">
//                                 <Link
//                                     to="/account/login"
//                                     className="nav-link pt-2 px-1 whishlist-nav"
//                                 >
//                                     <i className="fa fa-user-o px-2"></i>
//                                 </Link>
//                             </Nav.Item>

//                             <Nav.Item className="px-1 pt-1">
//                                 <div className="nav-link pt-2 px-1 whishlist-nav">
//                                     <SearchComponet />
//                                 </div>
//                             </Nav.Item>
//                         </div>

//                         <Navbar.Toggle aria-controls="basic-navbar-nav" />

//                         <Navbar.Collapse id="basic-navbar-nav">

//                             {/* Categories */}
//                             <Nav
//                                 className="m-auto text-capitalize"
//                                 activeKey={active}
//                                 onSelect={(selectedKey) => setActive(selectedKey)}
//                             >
//                                 {categoryList.map((category) => (
//                                     <NavDropdown
//                                         key={category.category_id}
//                                         title={category.category_name}
//                                         id={`category-${category.category_id}`}
//                                     >
//                                         {/* All Products */}
//                                         <NavDropdown.Item
//                                             as={Link}
//                                             to={`/${category.category_slug}`}
//                                         >
//                                             All Products
//                                         </NavDropdown.Item>

//                                         <NavDropdown.Divider />

//                                         {/* Sub Categories */}
//                                         {category.sub_categorys?.map((subCategory) => (
//                                             <NavDropdown.Item
//                                                 key={subCategory.sub_category_id}
//                                                 as={Link}
//                                                 to={`/${category.category_slug}/${subCategory.sub_category_slug}`}
//                                             >
//                                                 {subCategory.sub_category_name}
//                                             </NavDropdown.Item>
//                                         ))}
//                                     </NavDropdown>
//                                 ))}
//                             </Nav>

//                             {/* Desktop Icons */}
//                             <div className="store-section">
//                                 <Nav className="d-none d-lg-inline-flex">

//                                     <Nav.Item className="px-1 pt-1">
//                                         <Link
//                                             to="/wishlist"
//                                             className="nav-link pt-2 px-1 whishlist-nav"
//                                         >
//                                             <Badge bg="danger" className="rounded-5">
//                                                 {wishlistData.wishListDataCount.length}
//                                             </Badge>
//                                             <i className="fa fa-heart-o"></i>
//                                         </Link>
//                                     </Nav.Item>

//                                     <Nav.Item className="px-2 pt-1">
//                                         <Link
//                                             className="nav-link pt-2 px-1 whishlist-nav"
//                                             onClick={openCartSidebar}
//                                         >
//                                             <Badge bg="danger" className="rounded-5">
//                                                 {cart.length}
//                                             </Badge>
//                                             <i className="fa fa-shopping-bag"></i>
//                                         </Link>
//                                     </Nav.Item>

//                                     <Nav.Item className="px-1 pt-1">
//                                         {parsedTokenData ? (
//                                             <Link
//                                                 to="/account/myprofile"
//                                                 className="nav-link pt-2 px-1 whishlist-nav"
//                                             >
//                                                 <i className="fa fa-user-o px-2"></i>
//                                             </Link>
//                                         ) : (
//                                             <Link
//                                                 to="/account/login"
//                                                 className="nav-link pt-2 px-1 whishlist-nav"
//                                             >
//                                                 <i className="fa fa-user-o px-2"></i>
//                                             </Link>
//                                         )}
//                                     </Nav.Item>

//                                 </Nav>
//                             </div>

//                         </Navbar.Collapse>
//                     </div>
//                 </Navbar>
//             </section>

//             <CartSidebar
//                 isOpen={isCartSidebarOpen}
//                 closeSidebar={closeCartSidebar}
//             />
//         </>
//     );
// };

// export default MainHeader;



import React, { useEffect, useState } from 'react';
import { Navbar, Nav, Badge, NavDropdown } from 'react-bootstrap';
import HeaderTop from './HeaderTop';
import { Link } from 'react-router-dom';
import { fetch } from '../../utils';
import { useSelector } from 'react-redux';
import CartSidebar from '../component/CartSidebar';
import SearchComponet from '../component/SearchComponet';

const MainHeader = () => {
    const cart = useSelector((state) => state.cart?.items || []);
    const wishlistData = useSelector((state) => state.wishlistData);
    const wishlistCount = wishlistData?.wishListDataCount?.length || 0;

    const [active, setActive] = useState("home");
    const [categoryList, setCategoryList] = useState([]);
    const [isCartSidebarOpen, setIsCartSidebarOpen] = useState(false);
    const [isOverlayActive, setIsOverlayActive] = useState(false);

    const getCategryList = async () => {
        try {
            const response = await fetch("/category/hierarchy", "get", null, null);
            setCategoryList(response?.data?.data?.category || []);
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        getCategryList();
    }, []);

    const openCartSidebar = () => {
        setIsCartSidebarOpen(true);
        setIsOverlayActive(true);
    };

    const closeCartSidebar = () => {
        setIsCartSidebarOpen(false);
        setIsOverlayActive(false);
    };

    const tokenDataFromLocalStorage = localStorage.getItem("muskan_token_data");

    let parsedTokenData = null;

    try {
        parsedTokenData = tokenDataFromLocalStorage
            ? JSON.parse(tokenDataFromLocalStorage)
            : null;
    } catch (error) {
        parsedTokenData = null;
    }

    return (
        <>
            <HeaderTop />

            <div
                className={`overlay ${isOverlayActive ? 'active' : ''}`}
                onClick={closeCartSidebar}
            />

            <section className="navigation">
                <Navbar collapseOnSelect expand="lg">
                    <div className="container-fluid">

                        <Navbar.Brand
                            as={Link}
                            to="/"
                            className="navbar-brand"
                            aria-label="Sakhi Logo"
                        >
                            <picture>
                                <img
                                    decoding="async"
                                    loading="lazy"
                                    src={require('../assets/images/logo.webp')}
                                    alt="Sakhi"
                                    className="img-fluid logo-width"
                                />
                            </picture>
                        </Navbar.Brand>

                        <div className="d-inline-flex d-lg-none ms-auto">

                            <Nav.Item className="px-1 pt-1">
                                <Link
                                    to="/wishlist"
                                    className="nav-link pt-2 px-1 whishlist-nav"
                                >
                                    <Badge bg="danger" className="rounded-5">
                                        {wishlistCount}
                                    </Badge>
                                    <i className="fa fa-heart-o"></i>
                                </Link>
                            </Nav.Item>

                            <Nav.Item className="px-2 pt-1">
                                <Link
                                    to="#"
                                    className="nav-link pt-2 px-1 whishlist-nav"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        openCartSidebar();
                                    }}
                                >
                                    <Badge bg="danger" className="rounded-5">
                                        {cart.length}
                                    </Badge>
                                    <i className="fa fa-shopping-bag"></i>
                                </Link>
                            </Nav.Item>

                            <Nav.Item className="px-1 pt-1">
                                <Link
                                    to="/account/login"
                                    className="nav-link pt-2 px-1 whishlist-nav"
                                >
                                    <i className="fa fa-user-o px-2"></i>
                                </Link>
                            </Nav.Item>

                            <Nav.Item className="px-1 pt-1">
                                <div className="nav-link pt-2 px-1 whishlist-nav">
                                    <SearchComponet />
                                </div>
                            </Nav.Item>

                        </div>

                        <Navbar.Toggle aria-controls="basic-navbar-nav" />

                        <Navbar.Collapse id="basic-navbar-nav">

                            <Nav
                                className="m-auto text-capitalize"
                                activeKey={active}
                                onSelect={(selectedKey) => setActive(selectedKey)}
                            >
                                {categoryList.map((category) => (
                                    <NavDropdown
                                        key={category.category_id}
                                        title={category.category_name}
                                        id={`category-${category.category_id}`}
                                    >
                                        <NavDropdown.Item
                                            as={Link}
                                            to={`/${category.category_slug}`}
                                        >
                                            All Products
                                        </NavDropdown.Item>

                                        <NavDropdown.Divider />

                                        {category.sub_categorys?.map((subCategory) => (
                                            <NavDropdown.Item
                                                key={subCategory.sub_category_id}
                                                as={Link}
                                                to={`/${category.category_slug}/${subCategory.sub_category_slug}`}
                                            >
                                                {subCategory.sub_category_name}
                                            </NavDropdown.Item>
                                        ))}
                                    </NavDropdown>
                                ))}
                            </Nav>

                            <div className="store-section">
                                <Nav className="d-none d-lg-inline-flex">

                                    <Nav.Item className="px-1 pt-1">
                                        <Link
                                            to="/wishlist"
                                            className="nav-link pt-2 px-1 whishlist-nav"
                                        >
                                            <Badge bg="danger" className="rounded-5">
                                                {wishlistCount}
                                            </Badge>
                                            <i className="fa fa-heart-o"></i>
                                        </Link>
                                    </Nav.Item>

                                    <Nav.Item className="px-2 pt-1">
                                        <Link
                                            to="#"
                                            className="nav-link pt-2 px-1 whishlist-nav"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                openCartSidebar();
                                            }}
                                        >
                                            <Badge bg="danger" className="rounded-5">
                                                {cart.length}
                                            </Badge>
                                            <i className="fa fa-shopping-bag"></i>
                                        </Link>
                                    </Nav.Item>

                                    <Nav.Item className="px-1 pt-1">
                                        {parsedTokenData ? (
                                            <Link
                                                to="/account/myprofile"
                                                className="nav-link pt-2 px-1 whishlist-nav"
                                            >
                                                <i className="fa fa-user-o px-2"></i>
                                            </Link>
                                        ) : (
                                            <Link
                                                to="/account/login"
                                                className="nav-link pt-2 px-1 whishlist-nav"
                                            >
                                                <i className="fa fa-user-o px-2"></i>
                                            </Link>
                                        )}
                                    </Nav.Item>

                                </Nav>
                            </div>

                        </Navbar.Collapse>
                    </div>
                </Navbar>
            </section>

            <CartSidebar
                isOpen={isCartSidebarOpen}
                closeSidebar={closeCartSidebar}
            />
        </>
    );
};

export default MainHeader;